import React, { useState, useEffect } from "react";
import "./index.scss";
import Sidebar from "../sidebar";
import Header from "../header";

export default function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false); // desktop
  const [mobileOpen, setMobileOpen] = useState(false); // mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Détection resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fonction unique pour gérer burger click
  const handleToggleSidebar = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen); // mobile → overlay
    } else {
      setCollapsed(!collapsed); // desktop → collapse
    }
  };

  return (
    <div className={`app-layout d-flex ${collapsed ? "collapsed" : ""}`}>
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />

      {/* Overlay backdrop for mobile */}
      {mobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setMobileOpen(false)}></div>
      )}

      {/* Main content */}
      <div className="main-content flex-grow-1 d-flex flex-column">
        <Header
          onToggleSidebar={handleToggleSidebar}
          isSidebarOpen={isMobile && mobileOpen}
        />
        <div className="content p-3 p-md-5 ">{children}</div>
      </div>
    </div>
  );
}
